import type { UseFetchOptions } from 'nuxt/app'

export type RequestFn = <T>(url: string, opts?: UseFetchOptions<T>) => Promise<T>
export type ApiClient = {
  get: RequestFn
  post: RequestFn
  put: RequestFn
  delete: RequestFn
}

export const useApi = (): ApiClient => {
  const config = useRuntimeConfig()
  const requestFn = async <T>(resourceUrl: string, opts: UseFetchOptions<T> = {}) => {
    if (!opts.headers) {
      opts.headers = {}
    }

    if (!opts.headers['Accept']) {
      opts.headers['Accept'] = 'application/json'
    }

    const data = await $fetch(resourceUrl, {
      baseURL: config.public.apiUrl,
      ...opts,
    })

    return data as T
  }

  return {
    get: <T>(url: string, opts?: UseFetchOptions<T>) => requestFn<T>(url, opts),
    post: <T>(url: string, opts?: UseFetchOptions<T>) => requestFn<T>(url, { ...opts, method: 'POST' }),
    put: <T>(url: string, opts?: UseFetchOptions<T>) => requestFn<T>(url, { ...opts, method: 'PUT' }),
    delete: <T>(url: string, opts?: UseFetchOptions<T>) => requestFn<T>(url, { ...opts, method: 'DELETE' }),
  }
}
